import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const AddPurchase = () => {
  const [items, setItems] = useState([
    {
      id: Date.now(),
      category: "",
      name: "",
      stock_name: "",
      items_name: "",
      quantity: "",
      unit: "",
      total: "",
    },
  ]);
  const [errors, setErrors] = useState({});
  const [user_id, setUserId] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [invoice, setInvoice] = useState("");
  const [date, setDate] = useState("");
  const [purchaseBy, setPurchaseBy] = useState("");
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryItems, setCategoryItems] = useState({});
  const [kitchenId, setKitchenId] = useState(null);

  const navigate = useNavigate();

  // Load user & kitchen
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
    }
    const userid = localStorage.getItem("user_id");
    if (userid) setUserId(userid);
  }, []);

  // Fetch vendors & categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vendorRes, categoryRes] = await Promise.all([
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/"),
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/category/"),
        ]);
        setVendors(vendorRes.data);
        setCategories(categoryRes.data);
      } catch (err) {
        console.error("Error fetching vendors/categories:", err);
      }
    };
    fetchData();
  }, []);

  const fetchItemsByCategory = async (categoryId, rowId) => {
    if (!categoryId || !kitchenId) return;
    try {
      const res = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/itemlist/?categoryid=${categoryId}&kitchenid=${kitchenId}`
      );
      setCategoryItems((prev) => ({
        ...prev,
        [rowId]: res.data,
      }));
    } catch (err) {
      console.error(`Error fetching items for row ${rowId}:`, err);
    }
  };

  // Add/Remove items
  const handleAddItem = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  const handleRemoveItem = (id) => {
    if (items.length > 1) {
      setItems(items.filter((item) => item.id !== id));
    }
  };

  // File upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    const validFiles = files.filter((file) => {
      if (!validTypes.includes(file.type)) {
        alert(`File ${file.name} is not supported`);
        return false;
      }
      if (file.size > maxSize) {
        alert(`File ${file.name} is too large (max 5MB)`);
        return false;
      }
      return true;
    });

    setImages(validFiles);
    setImagePreviews(validFiles.map((file) => URL.createObjectURL(file)));
  };

  const uploadImages = async () => {
    if (!images.length) return [];
    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images[]", image, image.name);
    });

    try {
      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/upload_images.php",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.success) {
        return response.data.uploadedFiles.map((file) => file.fileUrl);
      } else {
        console.error("Image upload failed:", response.data.error);
        return [];
      }
    } catch (error) {
      console.error("Error uploading images:", error);
      return [];
    }
  };

  // Item change
  const calculateTotal = (quantity, unit) => {
    return (parseFloat(quantity) || 0) * (parseFloat(unit) || 0);
  };

  const handleItemChange = (id, field, value) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
            ...item,
            [field]: value,
            total:
              field === "quantity" || field === "unit"
                ? calculateTotal(
                  field === "quantity" ? value : item.quantity,
                  field === "unit" ? value : item.unit
                )
                : item.total,
          }
          : item
      )
    );
  };

  const handleReset = () => {
    setVendor("");
    setInvoice("");
    setDate("");
    setPurchaseBy("");
    setImages([]);
    setImagePreviews([]);
    setItems([
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    // Validate top-level fields
    if (!vendor) newErrors.vendor = "Vendor is required";
    if (!invoice) newErrors.invoice = "Invoice is required";
    if (!date) newErrors.date = "Date is required";
    if (!purchaseBy) newErrors.purchaseBy = "Purchase By is required";

    // Validate items
    items.forEach((item, index) => {
      if (!item.category) newErrors[`category_${index}`] = "Category required";
      if (!item.name) newErrors[`name_${index}`] = "Item required";
      if (!item.quantity) newErrors[`quantity_${index}`] = "Quantity required";
      if (!item.unit) newErrors[`unit_${index}`] = "Unit required";
      if (!item.total) newErrors[`total_${index}`] = "Total required";
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);

    try {
      // Upload images first
      const uploadedImageUrls = await uploadImages();
      const purchaseId = Math.floor(10000000 + Math.random() * 90000000);

      const payload = {
        kitchen_id: kitchenId,
        parchase_id: purchaseId,
        invoice_no: invoice,
        date,
        parchase_by: purchaseBy,
        Images: uploadedImageUrls,
        created_at: new Date().toISOString(),
        status: 1,
        del_action: "N",
        vendor,
        items: items.map((item) => ({
          parchase_id: purchaseId,
          category_id: item.category,
          items_id: item.name,
          stock_name: item.stock_name,
          items_name: item.items_name || "", // ensure string
          quantity: item.quantity,
          unit: item.unit,
          total_amount: item.total,
        })),
      };

      // Axios POST request
      const res = await axios.post(
        "https://api-ims.indevconsultancy.in/purchase_report_create.php",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          timeout: 15000
        }
      );


      alert(res.data.message || "Purchase added successfully!");
      navigate("/PurchaseReportList");
    } catch (err) {
      console.error("Error adding purchase:", err);
      alert(err.response?.data?.message || "Failed to add purchase. Network error?");
    } finally {
      setLoading(false);
    }
  };


  const grandTotal = items.reduce((sum, item) => sum + (Number(item.total) || 0), 0);

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6 text-start">
          <h5>Add Purchase</h5>
        </div>
        <div className="col-md-6 text-end">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end mb-0">
              <li className="breadcrumb-item active" aria-current="page">
                Add Expenditure
              </li>
              <li className="breadcrumb-item">
                <Link to="/purchasePO">List Purchase Items</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">Add Purchase</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Vendor Name</label>
                <select
                  className="form-select"
                  value={vendor}
                  onChange={(e) => setVendor(e.target.value)}
                >
                  <option value="">Select Vendor</option>
                  {vendors.map((v) => (
                    <option key={v.vendor_id} value={v.vendor_id}>
                      {v.vendor_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label">Invoice No.</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Invoice No."
                  value={invoice}
                  onChange={(e) => setInvoice(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label">Purchase By</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Purchase By"
                  value={purchaseBy}
                  onChange={(e) => setPurchaseBy(e.target.value)}
                />
              </div>
              <div className="col-12 mt-3">
                <label className="form-label">Images</label>
                <input
                  type="file"
                  className="form-control"
                  multiple // Allow multiple file selection
                  accept="image/*" // Accept only image files
                  onChange={handleImageUpload}
                />
                <div className="form-text">
                  You can select multiple images
                </div>
                {images.length > 0 && (
                  <div className="mt-2">
                    <small>
                      {images.length} file(s) selected
                    </small>
                  </div>
                )}
              </div>
            </div>

            {items.map((item) => (
              <div key={item.id} className="row g-2 mb-3 align-items-end">
                <div className="col-md-2">
                  <label className="form-label">Category</label>
                  <select
                    className="form-control"
                    value={item.category || ""}
                    onChange={(e) => {
                      const categoryId = e.target.value;
                      handleItemChange(item.id, "category", categoryId);
                      fetchItemsByCategory(categoryId, item.id);
                    }}
                  >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                      <option key={c.category_id} value={c.category_id}>
                        {c.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Item</label>
                  <select
                    className="form-control"
                    value={item.name || ""}
                    onChange={(e) => {
                      const selectedId = Number(e.target.value);
                      const selectedItem = categoryItems[item.id]?.find(
                        (it) => it.stock_id === selectedId
                      );
                      const unitPrice = selectedItem?.price || "";
                      const qty = item.quantity || 0;

                      handleItemChange(item.id, "name", selectedId);
                      handleItemChange(item.id, "stock_name", selectedItem?.stock_name || "");
                      handleItemChange(item.id, "items_name", selectedItem?.items_name || "");
                      handleItemChange(item.id, "unit", unitPrice);
                      handleItemChange(item.id, "total", qty * unitPrice);
                    }}
                  >
                    <option value="">Select Item</option>
                    {categoryItems[item.id]?.map((it) => (
                      <option key={it.stock_id} value={it.stock_id}>
                        {it.items_name || it.stock_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Quantity</label>
                  <div className="input-group">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control"
                      placeholder="Quantity"
                      value={item.quantity}
                      onChange={(e) => {
                        const qty = parseFloat(e.target.value);
                        handleItemChange(item.id, "quantity", qty);
                        handleItemChange(item.id, "total", qty * item.unit);
                      }}
                    />
                    <span className="input-group-text">kg</span>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Unit Price</label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="form-control"
                    placeholder="Unit"
                    value={item.unit}
                    onChange={(e) => {
                      const unitPrice = parseFloat(e.target.value);
                      handleItemChange(item.id, "unit", unitPrice);
                      handleItemChange(item.id, "total", item.quantity * unitPrice);
                    }}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Total</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Total"
                    value={item.total}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={handleAddItem}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                <div className="col-md-1">
                  <button
                    className="btn btn-danger w-100"
                    type="button"
                    onClick={() => handleRemoveItem(item.id)}
                    disabled={items.length === 1}
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                </div>
              </div>
            ))}
            <div className="text-end">
              <h4>Total Price: {grandTotal}</h4>
            </div>

            <div className="text-end">
              <button
                className="btn btn-secondary me-2"
                type="button"
                onClick={handleReset}
              >
                Clear
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPurchase;